<!--suppress TypeScriptUnresolvedVariable -->
<div class="ec-representatives-container">
    <ng-container *ngIf="tenants">
        <div class="ec-members-container">
            <div class="grey-border">
                <div fxLayout="row" fxLayoutAlign="space-between center" class="mb-32 mt-16">
                    <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="36px">
                        <button app-ghost-button (click)="onClickGotoDashboard()" class="pearl-white">
                            <app-icon name="fal-arrow-left"></app-icon>
                            {{'Back to dashboard'|i18n}}
                        </button>
                        <div app-input-container class="member-search-container"
                             *appVar="searchTextFilter as textFilterCtrl">
                            <input app-input [formControl]="textFilterCtrl"
                                   class="member-search"
                                   [spellcheck]="false"
                                   [placeholder]="'Search by first name, last name or company'|i18n">
                            <app-icon *ngIf="!!textFilterCtrl.value" name="fal-times" class="right-symbol clear"
                                      (click)="textFilterCtrl.setValue('')">
                            </app-icon>
                            <svg *ngIf="!textFilterCtrl.value" xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 512 512"
                                 class="right-symbol mag-glass">
                                <!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                                <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352c79.5 0 144-64.5 144-144s-64.5-144-144-144S64 128.5 64 208s64.5 144 144 144z"/>
                            </svg>
                        </div>
                        <div *ngIf="tenants.length > 1" fxLayout="row" fxLayoutAlign="start center"
                             fxLayoutGap="8px">
                            <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">
                                <span class="txt-h-16-4">{{('Client filter'|i18n) + ':'}}</span>
                            </div>
                            <div fxFlex app-input-container>
                                <mat-select app-small-select
                                            class="status-filter"
                                            [placeholder]="'Client'|i18n"
                                            [formControl]="searchFilters.selectedTenants"
                                            multiple>
                                    <mat-option *ngFor="let rootNode of tenants" [value]="rootNode"
                                                [disabled]="!canFilterTenant(rootNode)" class="mat-primary">
                                        {{rootNode.name}}
                                    </mat-option>
                                </mat-select>
                            </div>
                            <div fxLayout="row">
                                <button app-small-ghost-button class="app-base-button"
                                        (click)="resetTenantsFilter()">
                                    <app-icon name="fal-backspace" class="no-margin"></app-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div>
                        <button app-primary-button (click)="onClickNewRepresentative()"
                                [disabled]="!canCreateRep">
                            <app-icon name="fal-plus-circle"></app-icon>
                            {{'New representative'|i18n}}
                        </button>
                    </div>
                </div>
                <div>
                    <ng-container *appVar="members|async as members">
                        <ng-container *ngIf="members; else loadingMembers">
                            <ng-container *ngIf="members.members.length">
                                <table mat-table app-table [dataSource]="members.members"
                                       *appVar="expandedMember|async as expandedMember"
                                       multiTemplateDataRows class="member-table">
                                    <ng-container matColumnDef="chevron">
                                        <th mat-header-cell *matHeaderCellDef>
                                        </th>
                                        <td mat-cell *matCellDef="let row"
                                            class="chevron" [ngClass]="{'expanded': row === expandedMember}">
                                            <app-icon
                                                    [name]="row === expandedMember ? 'fal-chevron-down' : 'fal-chevron-right'">
                                            </app-icon>
                                        </td>
                                    </ng-container>
                                    <ng-container *ngIf="tenants.length > 0" matColumnDef="client">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div fxLayout="row" fxLayoutAlign="start">
                                                {{'Client'|i18n}}
                                            </div>
                                        </th>
                                        <td mat-cell *matCellDef="let row">
                                            {{getTenantName(row.representative.tenant)}}
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="firstName">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div fxLayout="row" fxLayoutAlign="start">
                                                {{'Name'|i18n}}
                                            </div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let row">{{row.representative.personal_data.first_name || '-'}}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="lastName">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div fxLayout="row" fxLayoutAlign="start center">
                                                {{'Surname'|i18n}}
                                                <button *ngIf="getSortDirection(SortCriterion.LAST_NAME) === SortDirection.ASC"
                                                        app-icon-button class="sort-button ml-16"
                                                        (click)="onClickSortBy(SortCriterion.LAST_NAME, SortDirection.DESC)">
                                                    <app-icon name="fal-sort-amount-up"></app-icon>
                                                </button>
                                                <button *ngIf="getSortDirection(SortCriterion.LAST_NAME) === SortDirection.DESC"
                                                        app-icon-button class="sort-button ml-16"
                                                        (click)="onClickSortBy(SortCriterion.LAST_NAME, SortDirection.ASC)">
                                                    <app-icon name="fal-sort-amount-down"></app-icon>
                                                </button>
                                            </div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let row">{{row.representative.personal_data.last_name || '-'}}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="companyName">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div fxLayout="row" fxLayoutAlign="start center">
                                                {{'Business name'|i18n}}
                                                <button *ngIf="getSortDirection(SortCriterion.COMPANY_NAME) === SortDirection.ASC"
                                                        app-icon-button class="sort-button ml-16"
                                                        (click)="onClickSortBy(SortCriterion.COMPANY_NAME, SortDirection.DESC)">
                                                    <app-icon name="fal-sort-amount-up"></app-icon>
                                                </button>
                                                <button *ngIf="getSortDirection(SortCriterion.COMPANY_NAME) === SortDirection.DESC"
                                                        app-icon-button class="sort-button ml-16"
                                                        (click)="onClickSortBy(SortCriterion.COMPANY_NAME, SortDirection.ASC)">
                                                    <app-icon name="fal-sort-amount-down"></app-icon>
                                                </button>
                                            </div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let row">{{row.representative.personal_data.company_name || '-'}}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="status">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div fxLayout="row" fxLayoutAlign="center">
                                                {{'Account status__{table}'|i18n}}
                                            </div>
                                        </th>
                                        <td mat-cell *matCellDef="let row" class="status">
                                            <div fxLayout="row" fxLayoutAlign="center">
                                                <div *appVar="row.account.enabled as isEnabled"
                                                     class="rep-status">
                                                    <div *ngIf="isDefined(row.account?.enabled)"
                                                         class="status-box"
                                                         [ngClass]="'representative-' + isEnabled">
                                                        <div fxLayout="row" fxLayoutAlign="center center"
                                                             [fxLayoutGap]="setGap(isEnabled)">
                                                            <div fxLayoutAlign="center center">
                                                                <app-icon
                                                                        [name]="isEnabled ? 'fal-check-circle' : 'fal-ban'"
                                                                        class="status-icon"
                                                                        [ngClass]="'representative-' + isEnabled">
                                                                </app-icon>
                                                            </div>
                                                            <div fxLayoutAlign="center center">
                                                                <div>{{(isEnabled ? 'Active' : 'Disabled')|i18n}}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="registered">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div fxLayout="row" fxLayoutAlign="center center">
                                                {{'Registered since'|i18n}}
                                            </div>
                                        </th>
                                        <td mat-cell *matCellDef="let row">
                                            <div fxLayout="row" fxLayoutAlign="center">
                                                <div>
                                                    {{isDefined(row.representative.created_at) ? (row.representative.created_at|i18nDate) : '--/--/--'}}
                                                </div>
                                            </div>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="out">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div fxLayout="row" fxLayoutAlign="center">
                                                {{'Disabled since'|i18n}}
                                            </div>
                                        </th>
                                        <td mat-cell *matCellDef="let row">
                                            <div fxLayout="row" fxLayoutAlign="center">
                                                <div>
                                                    {{isDefined(row.account?.disabled_on) ? (row.account.disabled_on|i18nDate) : '--/--/--'}}
                                                </div>
                                            </div>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="actions">
                                        <th mat-header-cell *matHeaderCellDef>
                                        </th>
                                        <td mat-cell *matCellDef="let row" class="actions">
                                            <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="24px">
                                                <button app-icon-button
                                                        [disabled]="!canEditRep"
                                                        [title]="'Edit representative settings'|i18n"
                                                        (click)="onClickEditRepresentative(row, $event)">
                                                    <app-icon name="fal-pencil-alt"></app-icon>
                                                </button>
                                                <button app-icon-button
                                                        [disabled]="!canDeleteRep"
                                                        [title]="'Remove representative'|i18n"
                                                        (click)="onClickDeleteRepresentative(row, $event)">
                                                    <app-icon name="fal-trash"></app-icon>
                                                </button>
                                            </div>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="expandedDetail">
                                        <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length">
                                            <div class="member-detail-container"
                                                 [@detailExpand]="row === expandedMember ? 'expanded' : 'collapsed'">
                                                <div class="member-details">
                                                    <app-representative-details [member]="row.representative"
                                                                                [account]="row.account"
                                                                                [canUpdate]="canEditRep"
                                                                                [show2fa]="true"
                                                                                [tenantsAndNetworks]="tenantsAndNetworks"
                                                                                (disableAccount)="onDisableAccount(row)"
                                                                                (reactivateAccount)="onReactivateAccount(row)"
                                                                                (forcePwdChange)="onForcePwdChange(row)"
                                                                                (reset2FA)="onReset2FA(row)"
                                                                                (updateTenantAndNetworks)="onUpdateTenantsAndNetworks($event)">
                                                    </app-representative-details>
                                                </div>
                                            </div>
                                        </td>
                                    </ng-container>
                                    <tr mat-header-row *matHeaderRowDef="displayedColumns">
                                    </tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="app-row"
                                        [ngClass]="{'app-expanded-row': expandedMember === row}"
                                        (click)="onSelectMember(row)">
                                    </tr>
                                    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']"
                                        class="app-detail-row app-border-row"
                                        [ngClass]="{'app-expanded-row': expandedMember === row}">
                                    </tr>
                                </table>
                            </ng-container>
                            <div *ngIf="!members.members.length" fxLayout="row" fxLayoutAlign="center">
                                {{'No representatives found'|i18n}}
                            </div>
                        </ng-container>
                        <mat-paginator #paginator app-paginator class="member-paginator"
                                       [ngClass]="{'collapsed': !members || members.total === 0 }"
                                       [length]="members?.total" [pageSize]="PAGE_SIZE"
                                       [pageSizeOptions]="PAGE_SIZES">
                        </mat-paginator>
                    </ng-container>
                </div>
            </div>
        </div>
    </ng-container>
</div>

<ng-template #editRepresentative let-data let-close="close">
    <div class="edit-member app-dialog-background">
        <app-edit-representative [community]="data.community"
                                 [member]="data.member"
                                 (edited)="data.editedMember = $event"
                                 (invited)="onSendInvitation(data.member, $event)"
                                 (valid)="data.valid = $event">
        </app-edit-representative>
    </div>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-24">
        <button app-large-primary-button [disabled]="!data.valid || !data.editedMember"
                (click)="onClickSaveEditedRepresentative(data.editedMember)">
            {{'Save'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #deleteRepresentative let-data let-close="close">
    <div class="ml-42 mr-42">
        {{'Are you sure you want to delete representative {0}?'|i18n:data.member.name}}
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between" app-dialog-actions>
        <button app-ghost-button (click)="close(false)">
            {{'No, cancel'|i18n}}
        </button>
        <button app-primary-button (click)="close(true)">
            {{'Yes, confirm'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #disableRepresentative let-data let-close="close">
    <div fxLayout="row" fxLayoutAlign="center center" class="ml-42 mr-42 mt-30">
        {{'You are about to disable {0} from using the app'|i18n:data.member.name}}
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" class="ml-42 mr-42 mt-30">
        {{'This action will take effect immediately but you can re-enable the user with the "Enable" button'|i18n}}
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between" app-dialog-actions>
        <button app-ghost-button (click)="close(false)">
            {{'No, cancel'|i18n}}
        </button>
        <button app-primary-button (click)="close(true)">
            {{'Yes, confirm'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #forcePwdChange let-data let-close="close">
    <div fxLayout="row" fxLayoutAlign="center center" class="ml-42 mr-42 mb-20">
        {{'You are about to ask the user {0} {1} to change the password in order to use the platform.'|i18n:data.firstName:data.lastName}}
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" class="ml-42 mr-42">
        {{'The user will see the password change request on next login.'|i18n}}
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between" app-dialog-actions>
        <button app-ghost-button (click)="close(false)">
            {{'No, cancel'|i18n}}
        </button>
        <button app-primary-button (click)="close(true)">
            {{'Yes, confirm'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #force2FAReset let-data let-close="close">
    <div fxLayout="row" fxLayoutAlign="center center" class="ml-42 mr-42 mb-20">
        {{'You are about to reset 2FA for the user {0} {1}.'|i18n:data.firstName:data.lastName}}
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" class="ml-42 mr-42">
        {{'On next login, the user will have to re-configure two-factor authentication.'|i18n}}
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between" app-dialog-actions>
        <button app-ghost-button (click)="close(false)">
            {{'No, cancel'|i18n}}
        </button>
        <button app-primary-button (click)="close(true)">
            {{'Yes, confirm'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #loadingMembers>
    <div fxLayout="row" fxLayoutAlign="center center" class="mt-24 mb-16">
        <mat-spinner app-spinner diameter="20"></mat-spinner>
        <span class="pl-8">{{'Loading representatives'|i18n}}...</span>
    </div>
</ng-template>

<ng-template #spinner let-data="data" let-close="close">
    <app-spinner [spinnerDataSubj]="data"
                 (closeSpinner)="close()">
    </app-spinner>
</ng-template>

<ng-template #notEnoughPerms>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-16">
        {{'Insufficient permissions to see representatives'|i18n}}
    </div>
</ng-template>
